import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NotificationBellComponent } from './components/notification-bell/notification-bell.component';
import { NotificationOverviewComponent } from './components/notification-overview/notification-overview.component';
import { NotificationDetailComponent } from './components/notification-detail/notification-detail.component';
import { NotificationReminderModalComponent } from './components/notification-reminder-modal/notification-reminder-modal.component';

@NgModule({
  declarations: [
    NotificationBellComponent,
    NotificationOverviewComponent,
    NotificationDetailComponent,
    NotificationReminderModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    FontAwesomeModule,
  ],
  exports: [NotificationBellComponent, NotificationOverviewComponent],
})
export class NotificationsModule {}
